import React from 'react';

import HDonationCard from '@/core/components/DonationCard/HDonationCard';
import VDonationCard from '@/core/components/DonationCard/VDonationCard';
import type DonationDomain from '@/core/lib/new-architecture/domain/donation.domain';

interface DonationCardProps {
  donation: DonationDomain;
  vertical?: true;
  horizontal?: true;
  contactGiver?: true;
  hideUser?: true;
}

const DonationCard: React.FC<DonationCardProps> = ({ donation, vertical, horizontal, contactGiver, hideUser }) => {
  if (vertical) return <VDonationCard donation={donation} contactGiver={contactGiver} hideUser={hideUser} />;

  if (horizontal) return <HDonationCard donation={donation} />;

  throw new Error('One of horizontal or vertical must be selected.');
};

export default DonationCard;
